import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import React from 'react';
import { Button, Panel } from '@michelin/acid-components';
import { useTranslation } from 'react-i18next';
import { Badge, Grid } from '@material-ui/core';
import { Translate } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
export default function TranslationsModal(props) {
    var t = useTranslation().t;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var buildTranslationLine = function (e) { return (React.createElement("li", null, e)); };
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: "xs", onClose: function () { return props.onClose(); }, "aria-labelledby": "customized-dialog-title", open: true },
        React.createElement(DialogTitle, { id: "form-dialog-title" },
            React.createElement(Grid, { container: true, alignItems: "baseline" },
                React.createElement(Grid, { item: true, xs: 8 }, t('Missing Translations')),
                React.createElement(Grid, { item: true, xs: 4, style: { textAlign: 'right', fontSize: '.8em' } },
                    React.createElement(Badge, { badgeContent: props.translations.length, color: "error" },
                        React.createElement(Translate, { color: "primary" }))))),
        React.createElement(DialogContent, { id: "dialog-content", dividers: true, style: { padding: 0 } },
            React.createElement(Panel, { variant: "none", style: { border: 0 }, spacing: 3 },
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement("ul", null, props.translations.map(function (e) { return buildTranslationLine(e); }))))),
            React.createElement("input", { value: props.translations.concat('\n'), id: "missingTranslationsInput", style: {
                    width: '100%', height: '0', border: '0', padding: '0', margin: '0', backgroundColor: 'transparent',
                } })),
        React.createElement(DialogActions, null,
            React.createElement(React.Fragment, null,
                React.createElement(Button, { size: "small", color: "default", style: { margin: '8px' }, onClick: function () {
                        var copyText = document.getElementById('missingTranslationsInput');
                        if (!copyText) {
                            enqueueSnackbar(t('Could not copy to clipboard'), {
                                variant: 'error',
                                anchorOrigin: {
                                    vertical: 'top',
                                    horizontal: 'right',
                                },
                            });
                            return;
                        }
                        /* Select the text field */
                        copyText.select();
                        copyText.setSelectionRange(0, 99999); /* For mobile devices */
                        /* Copy the text inside the text field */
                        document.execCommand('copy');
                        /* Alert the copied text */
                        enqueueSnackbar(t('Missing translations copied to clipboard'), {
                            variant: 'success',
                            anchorOrigin: {
                                vertical: 'top',
                                horizontal: 'right',
                            },
                        });
                    } }, t('Copy to Clipboard')),
                React.createElement(Button, { size: "small", color: "secondary", style: { margin: '8px' }, onClick: function () { return props.onClose(); } }, t('Close'))))));
}
//# sourceMappingURL=TranslationsModal.js.map